import { LegacyImage } from "../types/feedback.types";

export function getImageSrc(image?: LegacyImage): string | null {
    if (!image) return null;
    if (typeof image === "string") return image;
  
    if (image.mediumUri) return image.mediumUri;
    if (image.uri) return image.uri;
    return null;
  }
